module.exports = __webpack_public_path__ + "media/images/top/top_sm-9ef547c3bf5ab45ea1dcc7dfcc374de3.jpg";